import React, { Component } from "react";
import { TextField } from '@material-ui/core';
import moment from 'moment';
import { addOffsetToDate, subOffsetFromDate } from 'services/structure/dateUtils';

// Era um datepicker, agora é só Date
class DatePicker extends Component {

  state = {}

  constructor(props) {
    super();
    this.state.value = this.formatDate(props.value);
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({ value: this.formatDate(this.props.value)});
    }
  }

  maskDate = value => {
      if (!value) {
          return null;
      }
      return value
          .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
          .replace(/^(\d{2})(\d)/, '$1/$2') // captura os dois primeiros dígitos (dia)
          .replace(/\/(\d{2})(\d)/, '/$1/$2') // captura os próximos 2 digitos (mes)
  }

  handleDate = async e => {
    const dateStr = this.maskDate(e.target.value);
    this.setState({value: dateStr});
    // campo vazio
    if (!dateStr) {
      this.props.onChange(null, null);
      return;
    }
    // Data completa
    if (dateStr?.length === 10 ) {
      let dateMoment = moment(dateStr, "DD/MM/YYYY");
      const dateUpdated = subOffsetFromDate(dateMoment.toDate());
      if (isNaN(dateUpdated.getTime())) {
        this.props.onChange(null, "Data inválida");
        return;
      }
      this.props.onChange(dateUpdated, null);  
      return;
    }
    
    this.props.onChange(null, "Data inválida");
  }

  formatDate = (dateIn) => {
    if (!dateIn) {
      return "";
    }
    let dateOut = addOffsetToDate(dateIn);
    return moment(dateOut).format("DD/MM/YYYY");
  }

  render() {
      return (
          <TextField
              minLength="10"
              variant={this.props.variant} 
              margin={this.props.margin} 
              fullWidth={this.props.fullWidth} 
              required={this.props.required} 
              label={this.props.label} 
              name={this.props.name}
              disabled={this.props.disabled}
              className={`MuiOutlinedInput-root ${this.props.className}`}
              autoFocus
              onChange={this.handleDate}
              error={this.props.error}
              value={this.state.value}
              InputLabelProps={this.props.InputLabelProps}
              inputProps={{ maxLength: 10 }}
          />
      )
  }
}

export default DatePicker;